import { render, staticRenderFns } from "./LocationUsersView.vue?vue&type=template&id=223510a9&scoped=true&"
import script from "./LocationUsersView.vue?vue&type=script&lang=js&"
export * from "./LocationUsersView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223510a9",
  null
  
)

export default component.exports